// extracted by mini-css-extract-plugin
module.exports = {"container":"SidebarStripeContainer_container__xwDuF","imageContained":"SidebarStripeContainer_imageContained__15evg","title":"SidebarStripeContainer_title__23zY6"};